import React, { useEffect } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'

import CustomCard from '../../utils/components/CustomCard';
import { Box, Divider, Typography, Grid, Container, Breadcrumbs, Button } from '@mui/material';

function IndexInventario() {

    const auth = useSelector((state) => state.auth);
    let navigate = useNavigate();

    useEffect(() => {
        document.title = 'Inventario';
    }, [])

    return (

        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Inventario</Typography>
            </Box>
            <Button size='small' variant='outlined' onClick={() => navigate('/dashboard')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Divider variant="middle" className='my-3' />
            <Grid container spacing={3}>
                {cards.map((card, i) => {
                    if (card.auth.includes(auth.user.rol)) {
                        return (
                            <Grid item key={i} xs={12} sm={6} md={4}>
                                <CustomCard
                                    title={card.title}
                                    to={card.to}
                                    button={card.button}
                                    cardIco={card.cardIco}
                                    text={card.text}
                                    color={'primary.main'}
                                    btnColor={'primary'}
                                />
                            </Grid>
                        )
                    }
                    return null;
                })}
            </Grid>
            <br></br>
        </Container>
    )
}

const cards = [
    {
        title: "Consultar Productos",
        text: "Consulta el inventario de productos (Buscador)",
        button: "Consultar",
        cardIco: "fad fa-search fa-3x",
        to: "/inventario/consultarProductos",
        auth: ['Admin', 'Vendedor', 'Tecnico', 'Almacen', 'Secretaria', 'Ayudante']
    },
    {
        title: "Agregar producto",
        text: "Agrega un nuevo producto al inventario.",
        button: "Agregar",
        cardIco: "fad fa-plus fa-3x",
        to: "/inventario/agregarProducto",
        auth: ['Admin', 'Almacen']
    },
    {
        title: "Ingreso de productos",
        text: "Ingreso de productos al almacén.",
        button: "Ingreso",
        cardIco: "fad fa-inbox-in fa-3x",
        to: "/inventario/ingresos",
        auth: ['Admin', 'Almacen']
    },
    {
        title: "Devolucion de productos",
        text: "Devolucion de productos al almacén.",
        button: "Devoluciones",
        cardIco: "fad fa-backward fa-3x",
        to: "/inventario/devoluciones",
        auth: ['Admin', 'Almacen']
    },
    {
        title: "Salida de productos de almacén",
        text: "Consulta y validacion de solicitudes de salida de almacén.",
        button: "Salidas",
        cardIco: "fad fa-sign-out-alt fa-3x",
        to: "/inventario/salidas",
        auth: ['Admin', 'Almacen', 'Secretaria', 'Tecnico', 'Vendedor', 'Ayudante']
    },
    {
        title: "Vales de salida para servicio",
        text: "Generar vale de salida de material para servicio.",
        button: "Vales",
        cardIco: "fad fa-clipboard-check fa-3x",
        to: "/inventario/valeSalida",
        auth: ['Dios']
        // auth: ['Admin', 'Tecnico', 'Secretaria', 'Ayudante']
    },
    {
        title: "Gestionar Pedidos",
        text: "Gestiona los pedidos de productos a proveedores.",
        button: "Pedidos",
        cardIco: "fad fa-truck-container fa-swap-opacity fa-3x",
        to: "/pedidos",
        auth: ['Admin']
    },
    {
        title: "Movimientos de inventario",
        text: "Ver todos los movimientos de entrada y salida de almacén.",
        button: "Movimientos",
        cardIco: "fad fa-sync-alt fa-3x",
        to: "/inventario/tablaInventario",
        auth: ['Admin', 'Almacen', 'Secretaria', 'Ayudante']
    },
    {
        title: "Catálogos de Productos",
        text: "Consulta los catalogos de productos.",
        button: "Catálogos",
        cardIco: "fad fa-paste fa-3x",
        to: "/catalogos",
        auth: ['Admin']
    }
]

export default IndexInventario;